import get from './GET';
import post from './POST';
import put from './PUT';

export const GET = get;
export const POST = post;
export const PUT = put;
